export default "__VITE_ASSET__CJR$1b60__"